module.exports = __webpack_public_path__ + "static/quickbooks-logo-7dd06b14cf008dc8cc3c275777455440.png";